package com.daytimegaming.ourdailyfinances.di

import com.daytimegaming.ourdailyfinances.BuildKonfig
import com.daytimegaming.ourdailyfinances.data.billing.WebSubscriptionManager
import com.daytimegaming.ourdailyfinances.data.settings.SettingsManager
import com.daytimegaming.ourdailyfinances.data.settings.WebSettingsManager
import com.daytimegaming.ourdailyfinances.domain.billing.SubscriptionManager
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import org.koin.dsl.module

actual fun platformModule() = module {
    try {
        val options = FirebaseOptions(
            projectId = BuildKonfig.FIREBASE_PROJECT_ID,
            applicationId = BuildKonfig.FIREBASE_APPLICATION_ID,
            apiKey = BuildKonfig.FIREBASE_API_KEY,
            authDomain = BuildKonfig.FIREBASE_AUTH_DOMAIN,
            storageBucket = BuildKonfig.FIREBASE_STORAGE_BUCKET,
        )
        Firebase.initialize(options = options)
    } catch (e: Exception) {
        // Firebase already initialized
    }
    single<SettingsManager> { WebSettingsManager() }
    single<SubscriptionManager> { WebSubscriptionManager(get()) }
}

